"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateDate = void 0;
function validateDate(date) {
    if (typeof date !== 'string')
        return false;
    return Boolean(date.match(/^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/));
}
exports.validateDate = validateDate;
//# sourceMappingURL=validateDate.js.map